module.exports = __webpack_public_path__ + "static/media/COFFEE.73c57806.svg";